import { ElementType, IElement } from '../../../models/Element';

export interface SpecializationsQuestionItem {
  id: number;
  title: string;
  heading: string;
  description: string;
  button_url: string;
  button_title: string;
}

export type SpecializationsFAQ = IElement & {
  heading: string;
  item_list: Array<SpecializationsQuestionItem>;
};

export const defaultSpecializationQuestionItem: SpecializationsQuestionItem = {
  id: 0,
  title: 'Geen vraag, geen antwoord',
  heading: 'Hier komt een optionele titel',
  description:
    'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  button_url: '',
  button_title: 'Externe link',
};

export const defaultSpecializationFAQ: SpecializationsFAQ = {
  id: 0,
  name: ElementType.SPECIALIZATION_FAQ,
  heading: 'Veel gestelde vragen over SEO',
  item_list: [
    defaultSpecializationQuestionItem,
    defaultSpecializationQuestionItem,
    defaultSpecializationQuestionItem,
    defaultSpecializationQuestionItem,
  ],
};
